
export default {
    namespaced: true,
    state: () => ({
        permissionError: false,
        errorCode: null,
        errorMessage: '',
    }),
    mutations: {
        setPermissionError(state, { code, message }) {
            state.permissionError = true;
            state.errorCode = code;
            state.errorMessage = message;
        },
        clearError(state) {
            state.permissionError = false;
            state.errorCode = null;
            state.errorMessage = '';
        },
    },
};
